// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"615":"6fb42e0c","691":"cbf15b1d","722":"6ec517fe"}[chunkId] + ".css";
};